export const START_MOVE = 'START_MOVE';
export const SELECTED_CHECKER = 'SELECTED_CHECKER';
export const PHASES = [START_MOVE, SELECTED_CHECKER];
